import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Dashboard } from '../../models';
import { guidEmpty, toDictionary } from '../../common';
import { IDashboardHelperService } from '../../services';

class TileDisplayController implements angular.IComponentController {
    dashboardLink: string;
    dashboardNames: _.Dictionary<string>;
    dashboards: Dashboard[];
    isEditMode: boolean;
    item: any;

    static $inject = [
        '$state',
        'dashboardHelperService'
    ];

    constructor(
        private _$state: angular.ui.IStateService,
        private _dashboardHelperService: IDashboardHelperService) {
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['dashboards'] && changesObj['dashboards'].currentValue) {
            if (this.dashboards && this.dashboards.length > 0) {
                this.dashboardNames = this._dashboardHelperService.getDashboardNames(this.dashboards);
            }
        }
    }

    gotoDestination(guid: string, $event): void {
        if (guid && guid !== guidEmpty) {
            const selectedGuid = this._dashboardHelperService.getSelectedGroupGuid(guid, this.item?.viewModel, this.dashboards);
            const go = this._dashboardHelperService.getGotoDestination(guid, toDictionary(this.dashboards), selectedGuid);
            this._$state.go(go.route, go.params);
            this.preventPropagation($event);
        }
    }

    hasDashboardLink(guid: string): boolean {
        return (guid && guid !== guidEmpty);
    }

    preventPropagation($event: angular.IAngularEvent) {
        $event.stopPropagation();
        $event.preventDefault();
    }
}

export const wtTileDisplay: ComponentDefinition = {
    componentId: 'wtTileDisplay',
    controller: TileDisplayController,
    template: require('./tileDisplay.component.html'),
    controllerAs: 'vm',
    bindings: {
        isEditMode: '<',
        item: '<',
        dashboardLink: '<',
        dashboards: '<'
    }
};
